module.exports = __webpack_public_path__ + "static/scale-model-of-elgin-illinois-d8de8489290b3c512128d0fd03b90156.png";